import { useCvData } from '../../locales';
import CVPreviewNameV2 from '../../modules/cv-name-02';
import AboutMeV2 from '../../modules/about-me-02';

type Props = {}

const MainPage = (props: Props) => {
  const cv = useCvData();

  return (
    <div className="content-stretch flex flex-[1_0_0] items-center justify-center min-h-px min-w-px relative w-full pt-[50px] md:pt-[250px]">
      <div className="content-stretch flex gap-[10px] h-full items-start justify-end relative shrink-0 w-[320px]">
        <div className="content-stretch flex flex-[1_0_0] flex-col gap-[10px] h-full items-start justify-center min-h-px min-w-px pb-[150px] relative">
          <CVPreviewNameV2 Name={cv.name} SecondName={cv.secondName} SubName={cv.title} />
          <AboutMeV2 text={cv.about} />
        </div>
      </div>
    </div>

    // <div className='main-page'>
    //     <Card profile={cv}/>
    // </div>
  )
}

export default MainPage;